module.exports = __webpack_public_path__ + "static/media/logo-animated.cb1cb9c3.gif";